import { api_base } from '../api';
import { getShoppingCart, getWishList, setBillingInfo, getsliders } from '../actions';
import { dialog } from '../../scripts/confirm';
import { toast } from '../../scripts/toast';
import { router } from '../../routes/routes';
import * as types from '../mutation-types';
import Store from '../store';

export const Sliders = {
	// ---- GET ALL ----

	get(page = 1, data, cb) {
		$.ajax({
			url: api_base + '/admin/sliders?page=' + page,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + data.token
			},
			
			success: function (res) {
				cb(res.data);

				if (res.next_page_url) {
					sliders.get(++page, data , cb);
				}
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err, data);
			}
		});
	},

	getDisplay(cb) {
		$.ajax({
			url: api_base + '/sliders',
			method: 'GET',

			success: function (res) {
				cb(res.data);
			},

			error: function (err) {
				if (err.status == 500) {
					return toast({
						title: 'Servidor',
						content: 'Problemas con el servidor.'
					});
				}

				// console.log(err);
			}
		});
	},

	// ---- GET BY ID ----

	getById(data, id, cb) {
		$.ajax({
			url: api_base + '/admin/sliders/' + id,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				// console.log(err);
			}
		});
	},

	// ---- CREATE ----

	create(slider, user, component) {
		let  form = new FormData();
		for(let k in slider){
			form.append(k, slider[k]);
		}

		let promise = new Promise ((resolve, reject) => {
			$.ajax({
				url: api_base + '/admin/sliders',
				method: 'POST',
				data: form,
				cache: false,
				processData: false,
				contentType: false,
				headers: {
					Accept: 'application/json',
					Authorization: 'Bearer ' + user.token
				},

				success: function (res) {
					component.is_submited = false;
					resolve(res);
					toast({
						title: 'Crear Slider',
						content: 'El slider se ha creado correctamente.'
					});
					router.go({ name: 'admin_slider' })
				},

				error: function (err) {
					component.is_submited = false;
					reject(err);
					toast({
						title: 'Crear Slider',
						content: 'El slider no se ha creado (asegurate de insertar el enlace).'
					});
					// console.log(err);
				}
			});
		});

		return promise;
	},

	// ---- DELETE ----

	delete(user, slider, cb) {
		$.ajax({
			url: api_base + '/admin/sliders/' + slider.id,
			method: 'DELETE',
			headers: {
				Authorization: 'Bearer ' + user.token
			},

			success: function (res) {
				cb(res);
				toast({
					title: 'Eliminar Slider',
					content: 'El slider ' + slider.img_file_name + ' ha sido eliminado.'
				});
			},

			error: function (err) {
				toast({
					title: 'Eliminar Slider',
					content: 'El slider no se ha eliminado.'
				});
				// console.log(err);
			}
		});
	},

	// ---- UDPATE ----

	update(data, slider, cb) {
		$.ajax({
			url: api_base + '/admin/sliders/' + slider.id,
			method: 'PUT',
			data: slider,
			headers: {
				Authorization: 'Bearer ' + data.token
			},

			success: function (res) {
				cb(res);
			},

			error: function (err) {
				// console.log(err);
			}
		})
	},

	// ---- MOVE ----

	move(user, pos1, pos2, cb) {
		$.ajax({
			url: api_base + `/admin/sliders/move/order?dest=${ pos1 }&to_move=${ pos2 }`,
			method: 'GET',
			headers: {
				Authorization: 'Bearer ' + user.token,
				Accept: 'application/json'
			},

			success: function (res) {
				// console.log(res);
			},

			error: function (err) {
				// console.log(err);
			}
		});
	},
};


// WEBPACK FOOTER //
// ./src/store/api/sliders.js